"use client";

import { m as motion, useReducedMotion } from "framer-motion";

export function SubtleMesh() {
  const prefersReduced = useReducedMotion();

  return (
    <motion.div
      aria-hidden
      className="pointer-events-none absolute -inset-[10%] -z-10"
      style={{
        background: [
          "radial-gradient(55% 45% at 20% 20%, rgba(30,63,232,0.16) 0%, transparent 60%)",
          "radial-gradient(50% 40% at 85% 70%, rgba(34,211,238,0.09) 0%, transparent 55%)",
          "radial-gradient(65% 55% at 50% 100%, rgba(59,126,255,0.1) 0%, transparent 65%)",
        ].join(", "),
        filter: "blur(40px) saturate(130%)",
        opacity: 0.75,
      }}
      animate={
        prefersReduced
          ? undefined
          : {
              x: ["0%", "-2%", "1%"],
              y: ["0%", "1%", "-1%"],
              scale: [1, 1.04, 1.02],
            }
      }
      transition={{
        duration: 30,
        ease: "easeInOut",
        repeat: Infinity,
        repeatType: "reverse",
      }}
    />
  );
}
